const Crossequa = () => {
    return (
        <div>
            <p>
                This project was made as part of the <a target="_blank" href="https://konomondo.at/oer-game-jam/">3rd OER game jam</a>.
                <br />
                The game jam lasted for about 2.5 days. It started on Friday where we got to meet eachother and lasted the enitre weekend.
                The point of the gamejam was to make a game about learning math. So we were supposed to balance the fun and learning aspects of the game.
                I was in pair with a teammate, but I ended up doing most of the work myself.
                The game is about finding the "x" in the equations by performing basic arithmetic inside of a grid.
                Sort of like minesweeper, but with equations.
                It's not polished, so it does not have a main menu, sound or even an end goal.
                It was still a lot of work and was really fun.
                <br />
                The game is published <a target="_blank" href="https://surfingnerd.itch.io/crossequa">here</a>.
                Feel free to try it out.
            </p>
        </div>
    )
}

export default Crossequa;